(()=>{'use strict';
const measurementId='G-XERV12E9C9';
function allowed(){try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;}catch{return false;}}
function publish(name,details){
 if(!allowed()||!['bn_quiz_start','bn_quiz_complete','bn_quiz_share_click'].includes(name))return;
 const titles=['Know Your Motorcycles','Rallies, Roads & Road Stories','Motorcycles, Movies & Legends','Evel Knievel — “This Seemed Like a Good Idea”','Biker Lingo, Customs & Culture','Biker Bars — “I’ve Been There… I Think”','Two Wheels on TV','Name That Motorcycle'];
 const id=details?.quiz_id||'quiz-1';if(!/^quiz-[1-8]$/.test(id))return;const data={quiz_id:id,quiz_version:2,quiz_title:titles[Number(id.slice(5))-1],question_count:10};
 if(name==='bn_quiz_complete'&&Number.isInteger(details?.score)&&details.score>=0&&details.score<=10)data.score=details.score;
 if(name==='bn_quiz_share_click'&&['facebook','copy','native'].includes(details?.method))data.method=details.method;
 try{window.Shopify?.analytics?.publish?.(name,data);}catch{}
 try{
  if(typeof window.gtag!=='function'){
   window.dataLayer=window.dataLayer||[];window.gtag=function(){window.dataLayer.push(arguments);};
   window.gtag('js',new Date());
   const tag=document.createElement('script');tag.async=true;tag.src='https://www.googletagmanager.com/gtag/js?id='+measurementId;document.head.append(tag);
  }
  // Configure only this existing GA property and avoid a duplicate page view.
  if(!publish.configured){window.gtag('config',measurementId,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false});publish.configured=true;}
  window.gtag('event',name,{...data,send_to:measurementId});
 }catch{}
}
window.BNTriviaAnalytics={publish};
// Load the privacy API when it is not already supplied by the storefront.
try{if(!window.Shopify?.customerPrivacy&&typeof window.Shopify?.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{});}catch{}
})();
